import axios from "axios";
import { store } from "@/vuex/store.js";

const GRAPH_BASE = "https://graph.microsoft.com/v1.0";
let accessToken = store.state.aToken;
import permissioner from "../services/permissioner";

async function uploadFileSmall(groupId, folderId, file, tag) {
  console.log("setup tag", tag);
  const url = `${GRAPH_BASE}/groups/${groupId}/drive/items/${folderId}:/${file.name}:/content?@microsoft.graph.conflictBehavior=rename`;
  try {
    const response = await axios.put(url, file, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": file.type,
      },
    });
    return { success: true, data: { ...response.data, tag } };
  } catch (error) {
    console.error(`Failed to upload small file: ${file.name}`, error);
    return { success: false, error, fileName: file.name };
  }
}

async function uploadFileLarge(groupId, folderId, file, tag) {
  const url = `${GRAPH_BASE}/groups/${groupId}/drive/items/${folderId}:/${file.name}:/createUploadSession`;
  let large_file_uploaded_ret = {};
  try {
    const sessionResponse = await axios.post(url, {
      item:{
        "@microsoft.graph.conflictBehavior" : "rename"
      }
    }, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
     
    });
    const uploadUrl = sessionResponse.data.uploadUrl;

    console.log("session response", sessionResponse);

    const chunkSize = 5 * 1024 * 1024; // 5MB
    const chunks = Math.ceil(file.size / chunkSize);
    let start = 0;

    for (let i = 0; i < chunks; i++) {
      const end = Math.min(start + chunkSize, file.size);
      const chunk = file.slice(start, end);

      await axios
        .put(uploadUrl, chunk, {
          headers: {
            "Content-Range": `bytes ${start}-${end - 1}/${file.size}`,
          },
        })
        .then((res) => {
          console.log("Put data", res.data);
          large_file_uploaded_ret = res.data;
        });

      start = end;
    }

    return { success: true, data: { ...large_file_uploaded_ret, tag } };
  } catch (error) {
    console.error(`Failed to upload large file: ${file.name}`, error);
    return { success: false, error, fileName: file.name };
  }
}

export async function uploadFiles(
  groupId,
  folderId,
  files,
  defaultTag,
  activeTag
) {
  const successfulUploads = [];
  const unsuccessfulUploads = [];
  await permissioner.getLoggedInUser();
  accessToken = store.state.aToken;

  await Promise.all(
    files.map(async (file) => {
      const tag = file.tag || defaultTag || activeTag;
      const uploadHandler =
        file.size <= 5 * 1024 * 1024 ? uploadFileSmall : uploadFileLarge;
      const result = await uploadHandler(groupId, folderId, file, tag);

      if (result.success) {
        successfulUploads.push(result.data);
      } else {
        unsuccessfulUploads.push({
          fileName: result.fileName,
          error: result.error,
        });
      }
    })
  );

  return { successfulUploads, unsuccessfulUploads };
}
